import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class OverlaySummary extends Phaser.Group {
  constructor(game, score, genericHud) {
    super(game);

    this.genericHud = genericHud;

    // overlay
    this.overlay = this.game.make.image(0, 0, 'foodgame_overlay');
    this.addChild(this.overlay);
    this.overlay.inputEnabled = true;

    // label
    this.label = this.game.make.text(
      this.game.defaultWidth / 2,
      65,
      this.game.copy.getCopy('yourscore'),
      {
        font: '55px ' + this.game.titleFontStyle,
        fill: '#ffffff',
      }
    );
    this.label.anchor.set(0.5);
    this.addChild(this.label);

    // panel
    this.panel = this.game.make.image(
      this.game.defaultWidth / 2,
      308,
      'foodgame_gui',
      'score_panel_big.png'
    );
    this.panel.anchor.set(0.5);
    this.addChild(this.panel);

    // score
    this.score = this.game.make.text(0, -15, score, {
      font: '162px ' + this.game.titleFontStyle,
      fill: '#ffffff',
    });
    this.score.anchor.set(0.5);
    this.score.angle = -6;
    this.panel.addChild(this.score);

    // btn restart
    this.btnReplay = this.game.make.button(
      this.game.defaultWidth / 2 - 106,
      575,
      'foodgame_gui',
      null,
      null,
      'btn_replay.png',
      'btn_replay.png'
    );
    this.btnReplay.anchor.set(0.5);
    this.btnReplay.onInputDown.add(this.handlePressReplay, this);
    this.addChild(this.btnReplay);

    // btn continue
    this.btnContinue = this.game.make.button(
      this.game.defaultWidth / 2 + 106,
      575,
      'foodgame_gui',
      null,
      null,
      'btn_continue.png',
      'btn_continue.png'
    );
    this.btnContinue.anchor.set(0.5);
    this.btnContinue.onInputDown.add(this.handlePressContinue, this);
    this.addChild(this.btnContinue);
  }

  handlePressReplay() {
    this.genericHud.startGame();
  }

  handlePressContinue() {
    this.game.gameController.endMiniGame();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ui/OverlaySummary.js